import * as React from "react"

const SvgComponent = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={40} height={40} {...props}>
        <g transform="translate(-663 -1824)">
            <text
                data-name="\uE3DC"
                transform="translate(663 1864)"
                fill="#7209b7"
                fontSize={40}
                fontFamily="MaterialIcons-Regular, Material Icons"
            >
                <tspan x={0} y={0}>
                    {"\uE3DC"}
                </tspan>
            </text>
            <circle
                data-name="Ellipse 39"
                cx={5}
                cy={5}
                r={5}
                transform="translate(678 1839)"
                fill="#f72585"
            />
        </g>
    </svg>
)

export default SvgComponent
